import { $language } from '@/stores/Language'
import { $promotion } from '@/stores/PromotionStore'

// Map short language codes to proper Intl locale codes
const localeMap: Record<string, string> = {
  en: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
  cn: 'zh-CN',
  ja: 'ja-JP',
  pl: 'pl-PL',
}

const getLocale = () => localeMap[$language.get()] || 'en-US'

const priceFormatter = (amount: number | string, currency?: string | null) => {
  const parsedAmount = Number.parseFloat(amount.toString())
  
  // Special formatting for PLN - use spaces as thousands separators and "zł" suffix
  if (currency === 'PLN') {
    const hasDecimal = parsedAmount % 1 !== 0
    if (!hasDecimal) {
      // Format number with spaces as thousands separators (no decimals)
      return `${parsedAmount.toLocaleString('pl-PL').replace(/,/g, ' ')} zł`
    } else {
      // Format with 2 decimal places and spaces as thousands separators
      return `${parsedAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} zł`
    }
  }
  
  // Default formatting for other currencies
  return new Intl.NumberFormat(getLocale(), {
    style: 'currency',
    currency: currency ?? 'USD',
    currencyDisplay: 'symbol',
    maximumFractionDigits: 2,
  }).format(parsedAmount)
}

// Centralized price calculation functions
const getDiscountPercent = () => {
  const promotion = $promotion.get()
  return promotion ? Number.parseFloat(promotion.discountinpercent) : 0
}

const calculateDiscount = (subtotal: number) => {
  const discountPercent = getDiscountPercent()
  return subtotal * (discountPercent / 100)
}

const calculateFinalPrice = (subtotal: number) => {
  return subtotal - calculateDiscount(subtotal)
}

const hasActivePromotion = () => {
  return getDiscountPercent() > 0
}

export {
  calculateDiscount,
  calculateFinalPrice,
  getDiscountPercent,
  hasActivePromotion,
  priceFormatter,
}
